
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playlists/popular",
      function () {
        return require("private-next-pages/playlists/popular/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playlists/popular"])
      });
    }
  